import { LoomChoicePageTemplate } from '@/templates/try/cloud/loom/choose/loom-choice-page/src/loom-choice-page.template';

export const LoomChoicePage = () => <LoomChoicePageTemplate />;
